<template>
    <div class="charter-details">
        <home-nav></home-nav>
        <div class="charter-nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/charter' }">我要包车</el-breadcrumb-item>
                <el-breadcrumb-item>{{ teamName }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="charter-detail-box" id="charter-detail-box">
            <div class="charter-detail-img">
                <swiper :options="swiperOptionTop" class="gallery-top imgs" ref="swiperTop">
                    <swiper-slide class="slide-1 imgsList" v-for="(item,index) in imageData" :key="index">
                        <img :src="item" alt="">
                    </swiper-slide>
                    <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
                    <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
                </swiper>
                <!-- swiper2 Thumbs -->
                <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                    <swiper-slide class="slide-1" v-for="(item,index) in imageData" :key="index">
                        <img :src="item" alt="">
                    </swiper-slide>
                </swiper>
            </div>

            <div class="charter-detail-right">
                <p class="charter-detail-title">
                    {{ teamTitle }}
                </p>
                <div class="charter-detail-ul">
                    <div class="charter-detail-li" v-show="invoice">
                        可开发票
                    </div>
                    <div class="charter-detail-li" v-show="contract">
                        可签合同
                    </div>
                    <div class="charter-detail-li" v-show="insurance">
                        含座位险
                    </div>
                </div>

                <div class="charter-detail-service">
                    <div class="detail-service-list">
                        <div class="detail-service-num">{{ serverCount }}</div>
                        <div class="detail-service-text">服务人数</div>
                    </div>
                    <div class="detail-service-list">
                        <div class="detail-service-num">{{ responseSpeed }}</div>
                        <div class="detail-service-text">响应速度</div>
                    </div>
                    <div class="detail-service-list">
                        <div class="detail-service-num">{{ avgComments }}</div>
                        <div class="detail-service-text">好评率</div>
                    </div>
                </div>

                <div class="charter-map">
                    <div class="charter-map-name">
                        <div class="charter-map-text">公司：{{ companyName }}</div>
                        <div class="charter-img-list">
                            <el-popover
                                    placement="top-start"
                                    width="300"
                                    trigger="hover">
                                <div class="hoverImg">
                                    会员等级 1 ,会员到期时间 {{ vipTime }}
                                </div>
                                <img slot="reference" :src="vipImg" alt="">
                            </el-popover>
                            <el-popover
                                    placement="top-start"
                                    width="500"
                                    trigger="hover">
                                <div class="picture" v-if="zjImgsArr[0]">
                                    <img :src="zjImgsArr[0]" alt="">
                                </div>
                                <img slot="reference" :src="shiImg" alt="">
                            </el-popover>
                        </div>
                    </div>
                    <div class="charter-map-address">
                        地址：{{ companyAddress }}
                    </div>
                </div>

                <div class="contact-and-share">
                    <div class="contact-team" @click.stop="contactBtnDetail(teamId,companyPic,teamName)">
                        <img src="@/assets/images/charter/public_icon_lxcd_b.png" alt="">
                        <span class="">联系车队</span>
                    </div>
                    <div class="contact-team-online" @click.stop="contactBtnOnline()">
                      <img src="@/assets/images/charter/chat.png" alt="">
                      <span class="onlineBtn">在线咨询</span>
                    </div>
                    <div class="share-area">
                        <div class="share-collection-btn" @click="collectBtn()">
                            <img :src="isCollect ? collectImg : noCollectImg" alt="">
                            <span>收藏</span>
                        </div>
                        <div class="share-code-btn"
                             @mouseenter="codeMouseEnter()"
                             @mouseleave="codeMouseLeave()"
                        >
                            <img src="@/assets/images/charter/cd_icon_erweima.png" alt="">
                            <div class="codeApp" v-show="codeHover">
                                <img class="codeAppIcon" src="" alt="">
                                <div class="codeAppText">扫码下载App</div>
                            </div>
                        </div>
                        <div class="share-code-btn" @click="feedBack()">
                            <img src="@/assets/images/charter/cd_icon_jubao.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="service-box">
            <div class="service-box-left">
                <div class="characteristic" id="characteristic">
                    <p class="characteristic-title">
                        特色服务
                    </p>
                    <div class="characteristic-list">
                        <div class="characteristic-list-icon" v-for="(item,index) in serviceList" :key="index">
                            <img :src="imgUrl" alt="">
                            <span>{{ item }}</span>
                        </div>
                    </div>

                    <div class="characteristic-detail">
                        {{ serverContent ? serverContent : '暂无内容' }}
                    </div>
                </div>

                <div class="characteristic-show" :id="'id0'">
                    <p class="characteristic-title-car">
                        <span>车型展示</span>
                        <span>全部 {{ info.length }} 款</span>
                    </p>

                    <div class="display-model-list" v-show="info.length">
                        <div class="display-model-area"
                             v-for="(item,index) in info"
                             :key="index"
                             @click="seeMore(item.id,item.imgArr)"
                        >
                            <img class="display-model-car-img" :src="item.img_url" alt="">
                            <div class="display-model-title">
                                {{ item.brand }} {{ item.model }}
                            </div>
                            <div class="display-model-license">
                                <span>{{ item.seat }}座</span>/ <span>{{ item.license }}</span>/
                                <span>{{ item.buytime }}</span>
                            </div>
                        </div>
                    </div>

                    <!--pagesize 每页多少条数据
                    current_change 改变时会触发
                    currentPage 当前页
                    pager-count 页码按钮数量
                    info.length total总共多少条数据-->
                    <el-pagination
                            v-show="info.length"
                            class="el-pagination-car"
                            @size-change="handleSizeChange"
                            @current-change="currentPageChange"
                            :current-page.sync="currentPage"
                            layout="prev, pager, next, jumper"
                            :page-size="pagesizeCar"
                            :pager-count="5"
                            :total="allNumInfo"
                    >
                    </el-pagination>

                    <div v-show="!info.length" class="noCarList">
                        <img :src="noCarListIcon" alt="">
                        <div class="noTeamText">暂无车型图片</div>
                    </div>
                </div>

                <div class="company-detail" :id="'id1'">
                    <p class="characteristic-title">
                        公司详情
                    </p>
                    <div class="company-detail-item">
                        <div class="company-detail-item-box">
                            <span class="company-detail-item-title">服务项目：</span>
                            <p class="company-detail-content">
                                {{ serviceItems ? serviceItems : '暂无内容' }}
                            </p>
                        </div>
                        <div class="company-detail-item-box">
                            <span class="company-detail-item-title">车队介绍：</span>
                            <p class="company-detail-content">
                                {{ introduction ? introduction : '暂无内容' }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="company-detail" :id="'id2'">
                    <p class="characteristic-title">
                        费用说明
                    </p>
                    <div class="company-detail-item">
                        <div class="company-detail-item-box">
                            <span class="company-detail-item-title">费用包含：</span>
                            <p class="company-detail-content">
                                {{ notice ? notice : '暂无信息' }}
                            </p>
                        </div>
                        <div class="company-detail-item-box">
                            <span class="company-detail-item-title">费用不包含：</span>
                            <p class="company-detail-content">
                                司机住宿，司机伙食
                            </p>
                        </div>
                    </div>
                </div>

                <div class="company-detail" :id="'id3'">
                    <p class="characteristic-title">
                        包车须知
                    </p>
                    <p class="company-detail-textarea">
                        {{ explain ? explain : '暂无信息' }}
                    </p>
                </div>

                <div class="evaluate-list" :id="'id4'">
                    <p class="characteristic-title">
                        累计评价<span class="evaluate-count">({{ allComments }})</span>
                    </p>

                    <div class="evaluate-list-area">
                        <div class="evaluate-list-box" v-for="(item,index) in evaluateList" :key="index">
                            <img class="evaluate-list-img" :src="item.headUrl" alt="">
                            <div class="evaluate-list-detail">
                                <div class="evaluate-list-name">
                                    <span class="evaluate-list-user">{{ item.name }}</span> <span
                                        class="evaluate-list-time">{{ item.created_at }}</span>
                                </div>
                                <div class="evaluate-list-rate">
                                    <span class="evaluate-list-span">评价</span>
                                    <el-rate
                                            class="evaluate-list-rate-box"
                                            v-model="item.stars"
                                            disabled
                                            text-color="#ff9900"
                                            :colors=scoreColors
                                            disabled-void-color="#888">
                                    </el-rate>
                                </div>

                                <div class="evaluate-list-content">
                                    {{ item.content }}
                                </div>

                                <div class="evaluate-imgs" v-if="item.image">
                                    <img v-for="(itemIn, idx) in item.image" :key="idx" :src="itemIn" alt="">
                                </div>
                            </div>
                        </div>

                    </div>

                    <el-pagination
                            v-show="evaluateList.length"
                            class="el-pagination-ele"
                            layout="prev, pager, next, jumper"
                            @size-change="handleSizeChangePj"
                            @current-change="currentPageChangePj"
                            :page-size="pagesize"
                            :current-page.sync="currentPage"
                            :pager-count="5"
                            :total="allComments"
                    >
                    </el-pagination>
                </div>

                <!--车队评分-->
                <div class="score" :id="'id5'">
                    <div class="score-area">
                        <span>车队评分:</span>
                        <el-rate
                                v-model="value"
                                text-color="#ff9900"
                                :colors=scoreColors
                                show-score
                                disabled-void-color="#888"
                                score-template="{value}">
                        </el-rate>
                    </div>

                    <div class="score-area">
                        <span>评价内容:</span>
                        <el-input
                                class="score-area-textarea"
                                type="textarea"
                                :rows="6"
                                placeholder="请输入内容"
                                v-model="textarea">
                        </el-input>
                    </div>
                    <div class="upImg">
                        <div v-if="uploadFiles"
                             class="carImgDiv"
                             v-for="(item,index) in uploadFiles"
                             :key="index"
                        >
                            <img class="carImage" :src="item" alt="">
                            <div class="rightClose" @click="deleteCurrentImg(index)">
                                <img src="@/assets/images/charter/public_btn_deleteImg.png" alt="">
                            </div>
                        </div>

                        <el-upload
                                id="carImgArr"
                                multiple
                                :limit='5'
                                class="upImgAdd"
                                :action="uploadAction"
                                :headers="headers"
                                :show-file-list="false"
                                :on-success="morenTouxiangUpload"
                                :before-upload="beforeMorenTouxiangUpload"
                                :on-exceed="exceedMessage">
                            <div class="addImage">
                                <img src="@/assets/images/charter/addIcon.png" alt="">
                                <p>上传图片</p>
                            </div>
                        </el-upload>
                    </div>

                    <div class="evaluate-btn" @click="evaluateBtn()">评价</div>
                </div>
            </div>
            <div class="service-box-right-all">
                <div class="service-box-right-top">
                    <div class="service-box-right-title">
                        <div class="service-box-right-p">服务概况</div>
                    </div>
                    <div class="service-box-right-area">
                        <span class="service-box-right-bold">营业时间：</span>
                        <span class="service-box-right-time">
                            每天 6:00~23:00
                        </span>
                        <span class="service-box-right-bold">服务区域：</span>
                        <p class="service-box-right-list">
                            <span v-for="(item,index) in serverArea" :key="index">
                                {{ item }}
                                <span>、</span>
                            </span>
                        </p>
                    </div>
                </div>
                <div class="service-box-right">
                    <p class="box-right-title">
                        已有 853 人咨询 <br>
                        服务好评率99%
                    </p>
                    <el-input style="width:200px;margin: 10px auto 0;"
                              v-model="telephone"
                              placeholder="请输入手机号码"
                              oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                              maxlength="11"
                    >

                    </el-input>
                    <div class="box-right-btn" @click="toCharter()">
                        为我报价
                    </div>
                    <p class="box-right-text">
                        注：预约后车队会尽快回电与您联系，请保证电话真实畅通
                    </p>
                </div>
            </div>
        </div>

        <home-footer></home-footer>

        <div class="fixed-nav" v-if="scrollShow">
            <div class="fixed-nav-box">
                <ul class="fixed-nav-ul">
                    <li class="fixed-nav-li"
                        :class="currentNum == index ? 'fixed-nav-li-ac' : ''"
                        v-for="(item,index) in navList"
                        :key="index"
                        @click="navListClick(index)"
                    >
                        {{ item.text }}
                    </li>
                    <!--<li class="fixed-nav-li">车型展示</li>
                    <li class="fixed-nav-li">公司详情</li>
                    <li class="fixed-nav-li">费用说明</li>
                    <li class="fixed-nav-li">包车须知</li>
                    <li class="fixed-nav-li">累计评价</li>-->
                </ul>

                <div class="fixed-nav-right" @click.stop="contactBtnDetail(teamId,companyPic,teamName)">
                    <img src="@/assets/images/charter/public_icon_lxcd_b.png" alt="">
                    <span>联系车队</span>
                </div>


                <div class="service-box-right-fixed" v-if="scrollFixedShow">
                    <p class="box-right-title">
                        已有 853 人咨询 <br>
                        服务好评率99%
                    </p>
                    <el-input style="width:200px;margin: 10px auto 0;display: block;" v-model="telephoneFixed"
                              placeholder="请输入手机号码"></el-input>
                    <div class="box-right-btn" @click="toCharterFixed()">
                        为我报价
                    </div>
                    <p class="box-right-text">
                        注：预约后车队会尽快回电与您联系，请保证电话真实畅通
                    </p>
                </div>
            </div>
        </div>

        <!--虚拟号弹窗-->
        <div class="showTelephone" v-show="showTelephone">
            <div class="showTelephoneBox">
                <div class="closeImg" @click="showTelephone=false">
                    <span></span>
                    <div class="showTelephoneCenter">
                        温馨提示
                    </div>
                    <span>
                        <img src="@/assets/images/charter/yuanquan.png" alt="">
                    </span>
                </div>

                <div class="tipsTextBox">
                    <img class="tipsTextBoxImg" :src="companyPic" alt="">
                    <p class="tipsTextBoxName">{{ teamName }}</p>
                    <p class="tipsText">
                        此号码为虚拟号：有限期为3分钟
                    </p>
                    <div class="tipsTextBoxPhone">
                        <img src="@/assets/images/charter/telIocn.png" alt="">
                        <span>{{ xuniTelephone }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import {swiper, swiperSlide} from "vue-awesome-swiper";
    import homeFooter from '@/components/homeFooter';
    import {mapGetters} from 'vuex';

    export default {
        name: "charterDetails",
        components: {
            homeNav,
            swiper,
            swiperSlide,
            homeFooter
        },
        data() {
            return {
                teamName: '', //列表页传过来的车队名称
                teamId: '', //列表页传过来的车队id
                companyPic: '', //头像

                //轮播图配置
                swiperOptionTop: {
                    effect: "fade",
                    orderType: 0,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                },
                swiperOptionThumbs: {
                    spaceBetween: 20,
                    centeredSlides: true,
                    slidesPerView: 'left',
                    touchRatio: 0.5,
                    slideToClickedSlide: true,
                    // autoplay:true
                    autoplay: {
                        delay: 4000,
                        speed: 3000,
                        disableOnInteraction: true	//点击小图之后停止自动轮播
                    }
                },
                swiperSlides: [],
                //轮播图数据
                imageData: [
                    /*{
                        item: require('@/assets/images/charter/cd_icon_service01.png'),
                    },
                    {
                        item: require('@/assets/images/charter/cd_icon_service01.png'),
                    },
                    {
                        item: require('@/assets/images/charter/cd_icon_service01.png'),
                    }*/
                ],
                showTelephone: false, //联系车队显示虚拟号弹窗
                xuniTelephone: '', //虚拟号

                teamTitle: '', //标题
                invoice: 0, //发票
                contract: 0, //合同
                insurance: 0, //座位险
                serverCount: '', //服务人数
                responseSpeed: '', //响应速度
                avgComments: '', //好评率
                companyName: '', //公司名
                companyAddress: '', //公司地址
                vipImg: require('@/assets/images/charter/cd_icon_vip.png'), //vip图标
                shiImg: require('@/assets/images/charter/cd_icon_shiming.png'), //实名图标
                isCollect: 0, //是否收藏
                collectImg: require('@/assets/images/charter/cd_icon_shoucang.png'), //收藏图标
                noCollectImg: require('@/assets/images/charter/cd_icon_shoucang_no.png'), //未收藏图标
                codeHover: false,
                serviceList: [], //特色服务勾选
                serverContent: '', //特色服务文章
                allNumInfo: 1, //车型展示图片总数
                curPage: 1, //当前页码
                //车型展示
                info: [
                    /*{
                        imgUrl: require('@/assets/images/charter/cd_icon_service01.png'),
                        name: '本田 · 奥德赛',
                        seat: '7',
                        license: '闽A888888',
                        years: '3',
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_service01.png'),
                        name: '本田 · 奥德赛',
                        seat: '7',
                        license: '闽A888888',
                        years: '3',
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_service01.png'),
                        name: '本田 · 奥德赛',
                        seat: '7',
                        license: '闽A888888',
                        years: '3',
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_service01.png'),
                        name: '本田 · 奥德赛',
                        seat: '7',
                        license: '闽A888888',
                        years: '3',
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_service01.png'),
                        name: '本田 · 奥德赛',
                        seat: '7',
                        license: '闽A888888',
                        years: '3',
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_service01.png'),
                        name: '本田 · 奥德赛',
                        seat: '7',
                        license: '闽A888888',
                        years: '3',
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_service01.png'),
                        name: '本田 · 奥德赛',
                        seat: '7',
                        license: '闽A888888',
                        years: '3',
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_service01.png'),
                        name: '本田 · 奥德赛',
                        seat: '7',
                        license: '闽A888888',
                        years: '3',
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_service01.png'),
                        name: '本田 · 奥德赛',
                        seat: '7',
                        license: '闽A888888',
                        years: '3',
                    },*/
                ],
                noCarListIcon: require('@/assets/images/charter/null_img_bus.png'),
                currentPage: 1, // 当前页
                pagesize: 0, //每页条数
                pagesizeCar: 6,
                serviceItems: '', // 公司详情-服务项目
                introduction: '', // 公司详情-车队介绍
                notice: '', // 费用说明
                explain: '', // 须知
                // 评价列表
                evaluateList: [
                    /*{
                        imgUrl: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                        name: '张三',
                        time: '2021-06-04',
                        score: 0,
                        content: '不专业,态度差,不准时,电话报价高。东西打包好了等了一个小时又推一个小时，人影都没看到，骗子没一点诚信，还说等不了找别人，叫人这临时哪里找???，不专业,态度差,不准时,电话报价高。东西打包好了等了一个小时又推一个小时，人影都没看到，骗子没一点诚信，还说等不了找别人，叫人这临时哪里找???',
                        imgs: [
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                        ]
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                        name: '张三',
                        time: '2021-06-04',
                        score: 1,
                        content: '不专业,态度差,不准时,电话报价高。东西打包好了等了一个小时又推一个小时，人影都没看到，骗子没一点诚信，还说等不了找别人，叫人这临时哪里找???，不专业,态度差,不准时,电话报价高。东西打包好了等了一个小时又推一个小时，人影都没看到，骗子没一点诚信，还说等不了找别人，叫人这临时哪里找???',
                        imgs: [
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                        ]
                    },
                    {
                        imgUrl: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                        name: '张三',
                        time: '2021-06-04',
                        score: 2,
                        content: '不专业,态度差,不准时,电话报价高。东西打包好了等了一个小时又推一个小时，人影都没看到，骗子没一点诚信，还说等不了找别人，叫人这临时哪里找???，不专业,态度差,不准时,电话报价高。东西打包好了等了一个小时又推一个小时，人影都没看到，骗子没一点诚信，还说等不了找别人，叫人这临时哪里找???',
                        imgs: [
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                            {
                                imgIn: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                            },
                        ]
                    },*/
                ],
                allComments: 0, //总的评价数

                value: 5, // 发表评价星级
                textarea: '', // 发表评价内容
                dialogImageUrl: '', // 发表评价图片
                uploadFiles: [], //多图片上传数组
                uploadAction: 'http://api2.baostart.com/api/uploadFile', //图片上传接口
                headers: { //图片上传传递请求头
                    Authorization: this.$store.state.userToken
                },
                dialogVisible: false,
                uploadId: Math.random().toString(36).substr(2).toLocaleUpperCase(),
                loading: false,

                serverArea: [], //服务区域
                telephone: '',
                vipTime: '', //会员到期时间
                zjImgsArr: [], //营业执照

                telephoneFixed: '',

                navList: [
                    {
                        text: '车型展示'
                    },
                    {
                        text: '公司详情'
                    },
                    {
                        text: '费用说明'
                    },
                    {
                        text: '包车须知'
                    },
                    {
                        text: '累计评价'
                    }
                ],
                currentNum: 0,
                scrollShow: false,
                scrollFixedShow: false,
                listBoxState: true,//点击导航栏时，暂时停止监听页面滚动
                listBox: [0, 1, 2, 3, 4, 5],

                scoreColors: ['#FF5227', '#FF5227', '#FF5227'],

                // 特色服务
                imgUrl: require('@/assets/images/charter/cd_icon_yyfuwu.png'),
                company_timId:'',
                team_id:'',
                cityinfoid:'',
            }
        },
        created() {

        },

        mounted() {
            let timeId;
            window.addEventListener('scroll', () => {
                // 页面滚动停止100毫秒后才会执行下面的函数。
                clearTimeout(timeId);
                timeId = setTimeout(() => {
                    this.scrollToTop();
                }, 100);
            }, true);

            var that = this;
            // var teamId = this.$route.params.id;
            that.teamId = this.$route.query.id;
            that.companyPic = this.$route.query.companyPic;
            that.getUrlCurrent();
            that.getTeamDetail(that.teamId);
            that.getQualificationsDetail(that.teamId);
            that.getCharterNews(that.teamId, this.curPage);
            that.currentPageChangePj(1);
            window.scrollTo(0, 0);

            this.$nextTick(() => {
                const swiperTop = this.$refs.swiperTop.swiper;
                const swiperThumbs = this.$refs.swiperThumbs.swiper;
                console.log(swiperTop,swiperThumbs);
                swiperTop.controller.control = swiperThumbs;
                swiperThumbs.controller.control = swiperTop;
            })


            this.getUrl();
        },

        destroyed() {
            window.removeEventListener('scroll', this.scrollToTop);
        },

        computed:{
          ...mapGetters(['getuserTimUid','getuserIp'])
        },

        methods: {
            getUrl(){
                var now_url = localStorage.getItem('now_url');
                if(now_url == '' || now_url == null || now_url == undefined){
                    var url = window.location.href;
                    localStorage.setItem('now_url', url);
                }
            },
            // 获取车队详情信息
            getTeamDetail(id) {
                var that = this;
                that.$axios.post('/charterListDetail', {
                    fleet_id: id,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.teamName = res.data.company_name; //团队名
                        that.imageData = res.data.Carousel; //轮播图
                        that.teamTitle = res.data.title; //标题
                        that.invoice = res.data.is_invoice; //可开发票
                        that.insurance = res.data.is_insurance; //含座位险
                        that.serverCount = res.data.serverCount; //服务人数
                        that.responseSpeed = res.data.response_speed == '暂无数据' ? '暂无数据' : res.data.response_speed + 's'; //响速度
                        that.avgComments = res.data.avg_comments; //好评率
                        that.companyName = res.data.company_name; //公司名
                        that.companyAddress = res.data.company_address; //公司地址
                        that.isCollect = res.data.is_collect; //收藏
                        that.serviceList = res.data.tsfwArr; //特色服务
                        that.serverContent = res.data.server; //特色服务文章
                        // that.info = res.data.carInfo; //车型展示
                        that.serviceItems = res.data.service_items; //服务项目
                        that.introduction = res.data.introduction; //车队介绍
                        that.notice = res.data.notice; //费用说明
                        that.explain = res.data.explain; //包车须知
                        // that.evaluateList = res.data.comment; //评价列表
                        that.allComments = res.data.all_comments; //总的评价数量
                        that.pagesize = res.data.all_comments; //总的评价数量
                        that.serverArea = res.data.serverArea; //服务区域
                        that.company_timId = res.data.company_timId;
                        that.concatId = res.data.id; //id
                        that.vipTime = res.data.vip_time.split(' ')[0]
                        that.team_id = res.data.team_id;
                        that.cityinfoid = res.data.id;
                    } else {

                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            // 获取资质
            getQualificationsDetail(id) {
                this.zjImgsArr = [];
                this.$axios.post('/QualificationsDetail',{
                    fleet_id: id
                }).then(res => {
                    // 获得数据
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data);
                        this.zjImgsArr.push(res.data.pic);
                        this.zjImgsArr.push(res.data.pic2);
                    } else {
                        // layer.msg('系统错误，请刷新', {icon: 2});
                        this.$message.error('系统错误，请刷新！');
                    }
                }).catch(res => {
                    // 失败进行的操作
                })
            },

            getCharterNews(id, page) {
                var that = this;
                that.$axios.post('/charterCarShow', {
                    fleet_id: id,
                    page: page
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        var getDataList = res.data.data;
                        getDataList.forEach((item) => {
                            item.license = item.license.split('·')[0] + '·' + item.license.split('·')[1].substr(0, 1) + '***' + item.license.substring(4, 5);
                        })
                        that.info = getDataList; //车型展示
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message.error(res.message);
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            // 联系车队点击事件
            contactBtnDetail(team_id, companyPic, teamName) {
                var that = this
                that.$axios.post('/charterListDetail', {
                    fleet_id: team_id
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.getXnumDetail(res.data.team_id, res.data.mobile, companyPic, teamName)
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message.error('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            //在线
            contactBtnOnline() {
                // 判断是否登陆
                if (this.$store.state.userToken && this.$store.state.userName != '') {
                    var timuid = this.company_timId;
                    var uid = this.getuserTimUid;
                    var team_id = this.team_id;
                    var cityinfoid = this.cityinfoid;
                    var city = this.$store.state.cityName;
                    city = encodeURI(city);
                    var part = "t="+timuid+"&u="+uid+"&city="+city+"&team_id="+team_id+"&cityinfoid="+cityinfoid;
                    // console.log(part);return
                    part = window.btoa(part)

                    var url = "http://tim.baostart.com/?"+part;

                    window.open(url,'abc');
                } else {
                    this.$confirm('您尚未登录，是否前往登录！', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then((res) => {
                        this.$router.push({path: 'login'});
                    }).catch(() => {

                    });
                }
            },

            //打电话
            getXnumDetail(team_id, mobile, companyPic, teamName) {
                var that = this;
                var userIp = this.getuserIp;
                var url = localStorage.getItem('now_url');
                that.$axios.post('http://api.hbc1223.com/api/BindFictitious', {
                    city: this.$store.state.cityName,
                    referrer: '',
                    url: url,//当前页面url
                    info_id: userIp,//ip
                    from: '14',
                    team: team_id,
                    phone: mobile,
                    isList: '1',
                    source: '详情页联系车队'
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data)
                        //在这里写弹出号码
                        that.showTelephone = true;
                        that.xuniTelephone = res.data;
                        that.companyPic = companyPic;
                        that.teamName = teamName;
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message.error('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            // 收藏
            collectBtn() {
                var userToken = this.$store.state.userToken;
                var that = this;
                var operate;

                if(userToken){
                    if (that.isCollect) {
                        operate = 2;
                    } else {
                        operate = 1;
                    }
                    var index;
                    /*layui.use('layer', function () {
                        var layer = layui.layer;
                        index = layer.load(1, {
                            shade: [0.1, '#fff'] //0.1透明度的白色背景
                        });
                    });*/
                    that.$axios.post('/collectTeamOperate', {
                        city_info_id: that.teamId,
                        operate: operate
                    }).then((res) => {
                        // layer.closeAll();
                        res = res.data;
                        if (res.status == 200) {
                            if (operate == 1) {
                                that.isCollect = 1;
                                // layer.msg('收藏成功', {icon: 1});
                                this.$message('收藏成功');
                            } else if (operate == 2) {
                                that.isCollect = 0;
                                // layer.msg('取消收藏', {icon: 1});
                                this.$message('取消成功');
                            }
                        } else {
                            // layer.msg('您尚未登录，请先前往登录！', {icon: 2});
                            this.$message.error('您尚未登录，请先前往登录！');
                        }
                    }).catch((error) => {
                        // layer.closeAll();
                        console.log(error);
                    });
                } else {
                    this.$confirm('您尚未登录，是否前往登录！', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.$router.push({path: 'login'});
                    }).catch(() => {

                    });
                }
            },
            // 二维码移入
            codeMouseEnter() {
                this.codeHover = true;
            },

            // 二维码移出
            codeMouseLeave() {
                this.codeHover = false;
            },

            feedBack() {
                this.$message('功能开发中！');
                // layer.msg('功能开发中！', {icon: 1});
            },
            // 评价分页
            handleSizeChangePj(val) {
                console.log(`每页 ${val} 条`);
            },
            // 评价分页
            currentPageChangePj(val) {
                var teamId = this.teamId;
                // 评价分页点击请求
                this.$axios.post('/CumulativeComments', {
                    city_info_id: teamId,
                    page: val
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data)
                        res.data.forEach(item => {
                            item.stars = Number(item.stars);
                        });
                        this.evaluateList = res.data;
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message.error(res.message);
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            // 车型展示分页
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            // 车型展示分页
            currentPageChange(val) {
                // console.log(`当前页: ${val}`);
                var currentPageNum = val;
                this.getCharterNews(this.teamId, currentPageNum);
            },
            // 查看大图
            seeMore(curId, bigImgArr) {
                console.log(curId, bigImgArr);
            },
            // 默认头像--上传图片
            morenTouxiangUpload(res, file) {
                if (res.status == '200') {
                    var imgObj = {};
                    this.uploadFiles.push(res.data);
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },

            // 默认头像--上传图片
            beforeMorenTouxiangUpload(file) {
                const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/webp' || 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('图片格式不正确!(只能包含jpg，png，webp，JPEG)');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },

            // 车图图张数超出限制
            exceedMessage() {
                // this.$message('最多可上传10张车图');
                // layer.msg('最多可上传5张图片');
                this.$message.error('最多可上传5张图片');
            },

            // 删除当前图片
            deleteCurrentImg(imgId) {
                var that = this;
                that.uploadFiles.splice(imgId, 1);
            },

            // 发表评价
            evaluateBtn() {
                var that = this;
                var starNum = this.value;
                var evaText = this.textarea;
                var evaImgs = this.uploadFiles;
                var teamId = that.teamId;

                var isLogin = this.$store.state.userName;
                var userToken = this.$store.state.userToken;

                if (!isLogin || !userToken) {
                    this.$confirm('您尚未登录，暂无法评价，是否前往登录')
                        .then(_ => {
                            this.$router.push('/login');
                        })
                        .catch(_ => {
                        });

                    return;
                }

                /*if(starNum <5){
                    layer.msg('请选择五星', {icon: 2});
                    return;
                }*/

                if (evaText == '' || evaText.length <= 0) {
                    // layer.msg('您输入的内容为空', {icon: 2});
                    this.$message.error('您输入的内容为空');
                    return;
                }

                that.$axios.post('/PublishComments', {
                    content: evaText,
                    service_star: starNum,
                    imgArr: evaImgs,
                    city_info_id: teamId,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.getTeamDetail(that.teamId);
                        that.uploadFiles = [];
                        that.textarea = '';
                        // layer.msg('评价成功', {icon: 1});
                        this.$message('评价成功');
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message.error(res.message);
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            // 为我报价
            toCharter() {
                var phone = this.telephone;
                var userIp = this.getuserIp;
                var url = localStorage.getItem('now_url');
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (phone == undefined || phone <= 0) {
                    // layer.msg('手机号码不能为空~', {icon: 2});
                    this.$message('手机号码不能为空~');
                    return;
                }
                if (!myreg.test(phone)) {
                    /*layer.msg('请输入正确的手机号码！', {
                        icon: 2
                    });*/
                    this.$message('请输入正确的手机号码！');
                    return;
                }

               /* var index;
                layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/

                this.$axios.post('/CalculateQuotation', {
                    start_city: this.$store.state.cityName,
                    end_city: '',
                    source: "pc",
                    mobile: phone,
                    username: '',
                    people_num: '',
                    url: url,
                    info_id: userIp
                }).then((res) => {
                    res = res.data;
                    console.log(res)
                    if (res.status == 200) {
                        // layer.closeAll();
                        layer.msg('提交成功，请耐心等待回电！', {icon: 1});
                        this.$message('提交成功，请耐心等待回电！');
                    } else {
                        // layer.closeAll();
                        layer.msg('网络异常，请刷新！', {icon: 2});
                        this.$message('网络异常，请刷新！');
                    }

                }).catch((error) => {
                    // console.log(error);
                });

            },
            // 为我报价
            toCharterFixed() {
                var phone = this.telephoneFixed;
                var userIp = this.getuserIp;
                var url = localStorage.getItem('now_url');
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (phone == undefined || phone <= 0) {
                    // layer.msg('手机号码不能为空~', {icon: 2});
                    this.$message('手机号码不能为空~');
                    return;
                }
                if (!myreg.test(phone)) {
                    /*layer.msg('请输入正确的手机号码！', {
                        icon: 2
                    });*/
                    this.$message('请输入正确的手机号码！');
                    return;
                }

                /*var index;
                layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/

                this.$axios.post('/CalculateQuotation', {
                    start_city: this.$store.state.cityName,
                    end_city: '',
                    source: "pc",
                    mobile: phone,
                    username: '',
                    people_num: '',
                    url: url,
                    info_id: userIp,
                }).then((res) => {
                    res = res.data;
                    console.log(res)
                    if (res.status == 200) {
                        // layer.closeAll();
                        // layer.msg('提交成功，请耐心等待回电！', {icon: 1});
                        this.$message('提交成功，请耐心等待回电！');
                    } else {
                        // layer.closeAll();
                        // layer.msg('网络异常，请刷新！', {icon: 2});
                        this.$message('网络异常，请刷新！');
                    }

                }).catch((error) => {
                    // console.log(error);
                });
            },

            navListClick(idx) {
                this.currentNum = idx;
                this.$el.querySelector(`#id${idx}`).scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"  // 上边框与视窗顶部平齐。默认值
                });
                this.listBoxState = false;

                let timeId;
                clearTimeout(timeId);
                timeId = setTimeout(() => {
                    this.listBoxState = true;
                }, 200);
            },
            scrollToTop() {
                // 获取视窗高度
                var domHight = document.body.offsetHeight;
                // dom滚动位置
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // home-header  30
                // home-navheader  84
                // charter-nav 40
                // charter-detail-box 410
                // service-box margin-top 20
                // characteristic
                // 584
                var characteristicHeight = document.getElementById('characteristic').scrollHeight;
                var charterDetailHeight = document.getElementById('charter-detail-box').scrollHeight;
                // 固定导航栏-显示隐藏
                if (scrollTop > 104 + characteristicHeight + charterDetailHeight) {
                    this.scrollShow = true;
                } else {
                    this.scrollShow = false;
                    this.currentNum = 0;
                }

                if (scrollTop > 784) {
                    this.scrollFixedShow = true;
                } else {
                    this.scrollFixedShow = false;
                }

                if (this.listBoxState) {//作用是点击导航栏时，延迟这里执行。
                    this.listBox.map((v, i) => {
                        // 获取监听元素距离视窗顶部距离
                        var offsetTop = document.getElementById(`id${i}`).offsetTop;
                        // 获取监听元素本身高度
                        var scrollHeight = document.getElementById(`id${i}`).scrollHeight;
                        // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
                        // 则表示页面已经滚动到可视区了。
                        // console.log(scrollTop,offsetTop,scrollHeight)
                        if (scrollTop + 70 >= offsetTop && scrollTop <= (offsetTop + scrollHeight)) {
                            // 导航栏背景色选中
                            // this.navgatorIndex = i;
                            this.currentNum = i;
                        }
                    })
                }
            }
        },
    }
</script>

<style scoped>
    @import './charterDetails.css';
</style>



// WEBPACK FOOTER //
// src/pages/charterDetails/charterDetails.vue